import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { SortableExtractor } from '@common/UI/sortable/sortable.component';
import { Filterable } from '@common/utilities/Filterable';
import { DateRange, GoodReport, InvoiceRecord } from '@core/services/data.service';
import { PartnersService } from '@core/services/partners.service';
import { TagsService } from '@core/services/tags.service';

@Component({  
  templateUrl: './imports-viewer.component.html',
  styleUrls: ['./imports-viewer.component.scss']
})
export class ImportsViewerComponent implements OnInit {

  @Input()
  public range: { name: string, range: DateRange };

  @Input()
  public reports: GoodReport[];

  @Input()
  public SKU: string;

  @Input()
  public color: string;

  @Output()
  public changed = new EventEmitter<InvoiceRecord>();


  public unconfirmed(invoice: InvoiceRecord) {
    this.modal.of(this).hide();
    this.changed.emit(invoice);
  }

  public details: Filterable<GoodReport> = new Filterable<GoodReport>({ extractor: i => [i.Path[0]] });

  constructor(private tags: TagsService, private partners: PartnersService, private modal: ModalService) { }

  ngOnInit(): void {

    let lu: { [key: string]: GoodReport } = {};

    this.reports.forEach(i => {
      if (!lu[i.Path[0]]) {
        lu[i.Path[0]] = { ...i };
      }
      else {
        lu[i.Path[0]].Imports.LengthCount += i.Imports.LengthCount;
        lu[i.Path[0]].Imports.LengthQuantity += i.Imports.LengthQuantity;
        lu[i.Path[0]].Imports.LengthQuoteQuantity += i.Imports.LengthQuoteQuantity;
        lu[i.Path[0]].Imports.WeightCount += i.Imports.WeightCount;
        lu[i.Path[0]].Imports.WeightQuantity += i.Imports.WeightQuantity;
        lu[i.Path[0]].Imports.WeightQuoteQuantity += i.Imports.WeightQuoteQuantity;
        lu[i.Path[0]].Imports.BaseWorth += i.Imports.BaseWorth;

        lu[i.Path[0]].ProviderLosses.LengthCount += i.ProviderLosses.LengthCount;
        lu[i.Path[0]].ProviderLosses.LengthQuantity += i.ProviderLosses.LengthQuantity;
        lu[i.Path[0]].ProviderLosses.LengthQuoteQuantity += i.ProviderLosses.LengthQuoteQuantity;
        lu[i.Path[0]].ProviderLosses.WeightCount += i.ProviderLosses.WeightCount;
        lu[i.Path[0]].ProviderLosses.WeightQuantity += i.ProviderLosses.WeightQuantity;
        lu[i.Path[0]].ProviderLosses.WeightQuoteQuantity += i.ProviderLosses.WeightQuoteQuantity;
        lu[i.Path[0]].ProviderLosses.BaseWorth += i.ProviderLosses.BaseWorth;
      }
    })

    let source: GoodReport[] = [];

    for (let o in lu) source.push(lu[o]);

    this.details.source = source.filter(i => i.Imports.LengthCount + i.Imports.WeightCount > 0);
  }

  public partner(tag: string): string {
    let t = this.tags.get(tag);
    if (!t) return '';

    let p = this.partners.get(t.PartnerID);
    return p ? p.Name : '';
  }

  public extractor(field: string): SortableExtractor<GoodReport> {
    return {
      extract: i => {
        switch (field) {
          case 'Tag': return i.Path[0];
          case 'LengthQuantity': return i.Imports.LengthQuantity - i.ProviderLosses.LengthQuantity;
          case 'WeightQuantity': return i.Imports.WeightQuantity - i.ProviderLosses.WeightQuantity;
          case 'QuoteQuantity': return i.Imports.LengthQuoteQuantity - i.ProviderLosses.LengthQuoteQuantity + i.Imports.WeightQuoteQuantity - i.ProviderLosses.WeightQuoteQuantity;
          case 'ReducedQuantity': return i.Imports.LengthQuantity - i.ProviderLosses.LengthQuantity - (i.Imports.LengthQuoteQuantity - i.ProviderLosses.LengthQuoteQuantity) + i.Imports.WeightQuantity - i.ProviderLosses.WeightQuantity - (i.Imports.WeightQuoteQuantity - i.ProviderLosses.WeightQuoteQuantity);
          case 'Price': return i.Imports.BaseWorth / (i.Imports.LengthQuoteQuantity + i.Imports.WeightQuoteQuantity);
          case 'Subtotal': return i.Imports.BaseWorth - i.ProviderLosses.BaseWorth;
        }
      }
    }
  }

  public sum(field: string): number {
    return this.details.matches.sum(i => {
      switch (field) {
        case 'LengthCount': return i.Imports.LengthCount - i.ProviderLosses.LengthCount;
        case 'WeightCount': return i.Imports.WeightCount - i.ProviderLosses.WeightCount;
        case 'LengthQuantity': return i.Imports.LengthQuantity - i.ProviderLosses.LengthQuantity;
        case 'WeightQuantity': return i.Imports.WeightQuantity - i.ProviderLosses.WeightQuantity;
        case 'ReducedLength': return i.Imports.LengthQuantity - i.ProviderLosses.LengthQuantity - (i.Imports.LengthQuoteQuantity - i.ProviderLosses.LengthQuoteQuantity);
        case 'ReducedWeight': return i.Imports.WeightQuantity - i.ProviderLosses.WeightQuantity - (i.Imports.WeightQuoteQuantity - i.ProviderLosses.WeightQuoteQuantity);
        case 'QuoteLength': return i.Imports.LengthQuoteQuantity - i.ProviderLosses.LengthQuoteQuantity;
        case 'QuoteWeight': return i.Imports.WeightQuoteQuantity - i.ProviderLosses.WeightQuoteQuantity;
        case 'Subtotal': return i.Imports.BaseWorth - i.ProviderLosses.BaseWorth;
      }
    });
  }
}
